module.exports = __webpack_public_path__ + "static/media/settingsNav_black.e3def540.svg";